import { ResponseCodes } from '../../modules/ridp/types/responseCodes';
import { RIDP_ACTION_TYPES } from '../../constants/actionTypes/ridpActionTypes';
import { IUserInfo, IUserViewRef } from '../../modules/ridp/types/ridpTypes';

interface ridpAction {
    type: string;
    payload?: any;
}

export const INITIAL_STATE = {
    currentUserInfo: {},
    viewRef: '',
    ridpPrimaryResponse: {},
    ridpSecondaryResponse: {},
    responseBasedErrorMessage: '',
    ridpValidateFARSResponse: {},
};

export default (state = INITIAL_STATE, action: ridpAction) => {
    switch (action?.type) {
        case RIDP_ACTION_TYPES.GET_CURRENT_USER_INFORMATION: {
            return {
                ...state,
                currentUserInfo: action.payload as IUserInfo,
                ridpPrimaryResponse: {},
                ridpSecondaryResponse: {},
                responseBasedErrorMessage: '',
                ridpValidateFARSResponse: {},
            };
        }
        case RIDP_ACTION_TYPES.GET_CURRENT_USER_VIEWREF: {
            return {
                ...state,
                viewRef: action.payload as IUserViewRef,
                ridpPrimaryResponse: {},
                ridpSecondaryResponse: {},
                responseBasedErrorMessage: '',
            };
        }
        case RIDP_ACTION_TYPES.VALIDATE_CURRENT_USER_INFORMATION: {
            return {
                ...state,
                currentUserInfo: { ...state.currentUserInfo, ...action.payload?.verificationResponse },
                ridpPrimaryResponse: action.payload,
                ridpSecondaryResponse: {},
                responseBasedErrorMessage: '',
                ridpValidateFARSResponse: {},
            };
        }
        case RIDP_ACTION_TYPES.VALIDATE_IDENTITY_QUESTIONS: {
            return {
                ...state, 
                ridpSecondaryResponse: action.payload,
                responseBasedErrorMessage: '',
                ridpValidateFARSResponse: {},
            };
        }
        case RIDP_ACTION_TYPES.SET_ERROR_MESSAGE: {
            return {
                ...state,
                responseBasedErrorMessage: action.payload,
            };
        }
        case RIDP_ACTION_TYPES.UPLOAD_DOCUMENT: {
            if (action?.payload?.responseCode === ResponseCodes.HS000000) {
                return {
                    ...state,
                    currentUserInfo: {
                        ...state.currentUserInfo,
                        documentsUploaded: action.payload.documentsUploaded,
                    },
                };
            } else {
                return {
                    ...state,
                    responseBasedErrorMessage: 'ridp.manualverification.error.uploaddocument',
                };
            }
        }
        case RIDP_ACTION_TYPES.VALIDATE_FARS: {
            return {
                ...state,
                ridpValidateFARSResponse: action.payload,
            };
        }

        default:
            return state;
    }
};
